(function(w,d){
  'use strict';
  if (w.__ES_PDP_FORM_BOOT__) return;
  w.__ES_PDP_FORM_BOOT__ = true;

  function onJqReady(fn){
    if (typeof w.ES_jqReady === 'function') {
      w.ES_jqReady(fn);
      return;
    }
    function run(){ if (w.jQuery) fn(w.jQuery); }
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', run, { once:true });
    else run();
  }

  onJqReady(function($){
    var productData = w.__ES_PDP_PRODUCT_DATA || null;
    if (!productData) return;

    w.ES_PDP_COLOR_OPTION_INDEX = (typeof w.__ES_PDP_COLOR_OPTION_INDEX === 'number') ? w.__ES_PDP_COLOR_OPTION_INDEX : 0;
    w.ES_PDP_VARIANTS = productData.variants || [];
    w.ES_PDP_IMAGES = w.__ES_PDP_IMAGE_DATA || [];

    function preloadPdpImageAsset(src, onLoad, onError){
      if (!src) {
        if (typeof onError === 'function') onError();
        return;
      }
      var done = false;
      var pre = new Image();
      pre.decoding = 'async';
      pre.onload = function(){
        if (done) return;
        done = true;
        if (typeof onLoad === 'function') onLoad(pre);
      };
      pre.onerror = function(){
        if (done) return;
        done = true;
        if (typeof onError === 'function') onError();
      };
      pre.src = src;
      try { if (pre.complete && pre.naturalWidth) pre.onload(); } catch(e) {}
    }

    function swapPdpMainImageWhenReady($img, src, onAfter){
      try {
        if (!$img || !$img.length || !src) {
          if (typeof onAfter === 'function') onAfter();
          return;
        }
        var el = $img.get(0);
        if (!el) {
          if (typeof onAfter === 'function') onAfter();
          return;
        }
        var current = String($img.attr('src') || '').trim();
        if (current === src) {
          if (typeof onAfter === 'function') onAfter();
          return;
        }
        var token = (el.__esPdpSwapToken || 0) + 1;
        el.__esPdpSwapToken = token;
        var finalize = function(){
          if (!el || el.__esPdpSwapToken !== token) return;
          try { $img.addClass('es-image-fading'); } catch(_e0) {}
          $img.attr('src', src).attr('data-src', src);
          var raf = w.requestAnimationFrame || function(fn){ return w.setTimeout(fn, 16); };
          raf(function(){
            raf(function(){
              if (!el || el.__esPdpSwapToken !== token) return;
              try { $img.removeClass('es-image-fading'); } catch(_e1) {}
              if (typeof onAfter === 'function') {
                w.setTimeout(function(){
                  if (!el || el.__esPdpSwapToken !== token) return;
                  try { onAfter(); } catch(_e2) {}
                }, 20);
              }
            });
          });
        };
        preloadPdpImageAsset(src, finalize, finalize);
      } catch(e) {
        if (typeof onAfter === 'function') { try { onAfter(); } catch(_e3) {} }
      }
    }


    function applyPdpSoldOutCtaVisual(target, forceState){
      try {
        var $buttons = target && target.jquery ? target : $(target || '#AddToCartForm .es-pdp-primary-cta, #AddToCartForm .shop-button-soldout');
        $buttons.each(function(){
          var el = this;
          if (!el) return;
          var $el = $(el);
          var txt = $.trim($el.text() || $el.val() || '').toLowerCase();
          var isOos = (typeof forceState === 'boolean') ? forceState : (
            el.disabled ||
            $el.hasClass('disabled') ||
            $el.hasClass('shop-button-soldout') ||
            /out\s+of\s+stock|sold\s+out|unavailable/.test(txt)
          );
          if (isOos) {
            $el.addClass('es-pdp-oos-visual');
            try { el.setAttribute('aria-disabled', 'true'); } catch(_e0) {}
            try {
              el.style.setProperty('background', '#F5F1E7', 'important');
              el.style.setProperty('background-color', '#F5F1E7', 'important');
              el.style.setProperty('background-image', 'none', 'important');
              el.style.setProperty('border', '1px solid #DDD3C3', 'important');
              el.style.setProperty('color', '#6F6758', 'important');
              el.style.setProperty('box-shadow', 'none', 'important');
              el.style.setProperty('opacity', '1', 'important');
              el.style.setProperty('filter', 'none', 'important');
              el.style.setProperty('text-shadow', 'none', 'important');
              el.style.setProperty('cursor', 'not-allowed', 'important');
            } catch(_e1) {}
            try {
              $el.find('*').each(function(){
                this.style.setProperty('color', '#6F6758', 'important');
                this.style.setProperty('opacity', '1', 'important');
                this.style.setProperty('filter', 'none', 'important');
                this.style.setProperty('text-shadow', 'none', 'important');
              });
            } catch(_e2) {}
          } else {
            $el.removeClass('es-pdp-oos-visual');
            try { el.removeAttribute('aria-disabled'); } catch(_e3) {}
            try {
              ['background','background-color','background-image','border','color','box-shadow','opacity','filter','text-shadow','cursor'].forEach(function(prop){
                el.style.removeProperty(prop);
              });
            } catch(_e4) {}
            try {
              $el.find('*').each(function(){
                ['color','opacity','filter','text-shadow'].forEach(function(prop){ this.style.removeProperty(prop); }, this);
              });
            } catch(_e5) {}
          }
        });
      } catch(e) {}
    }

    function initLinkedOptions(){
      if (!productData.options || productData.options.length <= 1) return;
      var ShopifyNS = w.Shopify = w.Shopify || {};
      var linkedObserver = null;
      var linkedPagehideHandler = null;
      var linkedPageshowHandler = null;
      var optionsMap = {};

      function disconnectObserver(){
        if (linkedObserver && typeof linkedObserver.disconnect === 'function') {
          try { linkedObserver.disconnect(); } catch(e) {}
        }
        linkedObserver = null;
      }

      function buildMap(){
        optionsMap = {};
        (productData.variants || []).forEach(function(variant){
          if (!variant) return;
          optionsMap.root = optionsMap.root || [];
          optionsMap.root.push(variant.option1);
          optionsMap.root = ShopifyNS.uniq(optionsMap.root);
          if ((productData.options || []).length > 1) {
            var key = variant.option1;
            optionsMap[key] = optionsMap[key] || [];
            optionsMap[key].push(variant.option2);
            optionsMap[key] = ShopifyNS.uniq(optionsMap[key]);
          }
          if ((productData.options || []).length === 3) {
            var key3 = variant.option1 + ' / ' + variant.option2;
            optionsMap[key3] = optionsMap[key3] || [];
            optionsMap[key3].push(variant.option3);
            optionsMap[key3] = ShopifyNS.uniq(optionsMap[key3]);
          }
        });
      }

      function updateSelector(selectorIndex){
        var key, $selector;
        if (selectorIndex === 0) {
          key = 'root';
          $selector = $('.single-option-selector').eq(0);
        } else if (selectorIndex === 1) {
          key = $('.single-option-selector').eq(0).val();
          $selector = $('.single-option-selector').eq(1);
        } else {
          key = $('.single-option-selector').eq(0).val() + ' / ' + $('.single-option-selector').eq(1).val();
          $selector = $('.single-option-selector').eq(2);
        }
        if (!$selector.length) return;
        var initialValue = $selector.val();
        var availableOptions = optionsMap[key] || [];
        $selector.empty();
        availableOptions.forEach(function(option){
          $selector.append($('<option></option>').val(option).html(option));
        });
        $('.swatch[data-option-index="' + selectorIndex + '"] > .es-swatch-strip > [data-value], .swatch[data-option-index="' + selectorIndex + '"] > [data-value]').each(function(){
          var $item = $(this);
          var radio = $item.find(':radio');
          if ($.inArray($item.attr('data-value'), availableOptions) !== -1) {
            var esOriginalSoldout = String($item.attr('data-es-soldout') || '') === '1';
            $item.toggleClass('soldout', esOriginalSoldout).show();
            radio.removeAttr('disabled').removeAttr('aria-disabled').removeAttr('checked');
          } else {
            $item.addClass('soldout').hide();
            radio.removeAttr('checked').attr('disabled', 'disabled').attr('aria-disabled', 'true');
          }
        });
        if ($.inArray(initialValue, availableOptions) !== -1) $selector.val(initialValue);
        $selector.trigger('change');
      }

      function bindChangeHandlers(){
        var $sel0 = $('.single-option-selector').eq(0);
        var $sel1 = $('.single-option-selector').eq(1);
        $sel0.off('change.esLinkedOptions').on('change.esLinkedOptions', function(){
          updateSelector(1);
          if ((productData.options || []).length === 3) updateSelector(2);
          return true;
        });
        $sel1.off('change.esLinkedOptions').on('change.esLinkedOptions', function(){
          if ((productData.options || []).length === 3) updateSelector(2);
          return true;
        });
      }

      function runLinking(){
        var $selectors = $('.single-option-selector');
        if (!$selectors.length) return false;
        buildMap();
        updateSelector(0);
        if ((productData.options || []).length > 1) updateSelector(1);
        if ((productData.options || []).length === 3) updateSelector(2);
        bindChangeHandlers();
        disconnectObserver();
        return true;
      }

      function cleanupLinked(){
        disconnectObserver();
        $('.single-option-selector').eq(0).off('change.esLinkedOptions');
        $('.single-option-selector').eq(1).off('change.esLinkedOptions');
        if (linkedPagehideHandler) {
          try { w.removeEventListener('pagehide', linkedPagehideHandler); } catch(e) {}
        }
        if (linkedPageshowHandler) {
          try { w.removeEventListener('pageshow', linkedPageshowHandler); } catch(e) {}
        }
      }

      if (w.__esLinkedOptionsCleanup) {
        try { w.__esLinkedOptionsCleanup(); } catch(e) {}
      }
      w.__esLinkedOptionsCleanup = cleanupLinked;

      if (!runLinking()) {
        var addToCartForm = $('form[action="/cart/add"]').get(0);
        if (w.MutationObserver && addToCartForm) {
          linkedObserver = new MutationObserver(function(mutations){
            for (var i = 0; i < mutations.length; i++) {
              var m = mutations[i];
              if (m.target && m.target.nodeType === 1 && ((m.target.matches && m.target.matches('.single-option-selector')) || (m.target.querySelector && m.target.querySelector('.single-option-selector')))) {
                if (runLinking()) return;
              }
              if (!m.addedNodes || !m.addedNodes.length) continue;
              for (var j = 0; j < m.addedNodes.length; j++) {
                var node = m.addedNodes[j];
                if (!node || node.nodeType !== 1) continue;
                if ((node.matches && node.matches('.single-option-selector')) || (node.querySelector && node.querySelector('.single-option-selector'))) {
                  if (runLinking()) return;
                }
              }
            }
          });
          linkedObserver.observe(addToCartForm, { childList:true, subtree:true });
        }
      }

      linkedPagehideHandler = function(){
        disconnectObserver();
      };
      linkedPageshowHandler = function(){
        if (!$('.single-option-selector').length) return;
        try { runLinking(); } catch(e) {}
      };
      w.addEventListener('pagehide', linkedPagehideHandler);
      w.addEventListener('pageshow', linkedPageshowHandler);
    }

    w.ES_PDP_HoverSwap = w.ES_PDP_HoverSwap || (function(){
      var $overlay = null;
      var $wrapEl = null;
      var initialized = false;
      var HOVER_DELAY_MS = 160;
      var DESKTOP_MIN_WIDTH = 992;
      var hoverTimer = null;
      var lastAlt = '';

      function normalize(url){
        if(!url) return '';
        var clean = String(url).replace(/^https?:/,'').split('?')[0];
        clean = clean
          .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|1024x1024|2048x2048|master)(?=\.)/i,'')
          .replace(/_(\d+)(x\d+)?x?(?=\.)/i,'');
        return clean;
      }

      function shouldEnable(){
        try{
          if(w.innerWidth < DESKTOP_MIN_WIDTH) return false;
          if(w.matchMedia && w.matchMedia('(hover: hover) and (pointer: fine)').matches) return true;
          return false;
        }catch(e){
          return w.innerWidth >= DESKTOP_MIN_WIDTH;
        }
      }

      function findWrap(){
        var $w = $('.js_prod_main').first();
        if($w.length) return $w;
        var $main = $('.main_img .engoj_img_main').first();
        if(!$main.length) $main = $('.engoj_img_main').first();
        if(!$main.length) return $();
        $w = $main.closest('.img_thumb, .product-single__photo, .product-media, .product-gallery, .product-images');
        if($w.length) return $w;
        return $main.parent();
      }

      function ensureOverlay(){
        if(initialized) return;
        if(!shouldEnable()) return;
        var $wrap = findWrap();
        if(!$wrap.length) return;
        $wrapEl = $wrap;
        $wrapEl.addClass('es-pdp-hover-swap');
        if(!$wrapEl.find('.es-pdp-hover-alt').length){
          $overlay = $('<img class="es-pdp-hover-alt" alt="" aria-hidden="true" loading="lazy" draggable="false" />');
          $wrapEl.append($overlay);
        } else {
          $overlay = $wrapEl.find('.es-pdp-hover-alt').first();
        }
        bindHover();
        bindGalleryEvents();
        initialized = true;
      }

      function bindHover(){
        if(!$wrapEl || !$wrapEl.length) return;
        if($wrapEl.data('esHoverSwapBound')) return;
        $wrapEl.data('esHoverSwapBound', '1');
        $wrapEl.on('mouseenter', function(){
          if(!shouldEnable()) return;
          if(!$overlay || !$overlay.length) return;
          if(!$overlay.attr('src')) return;
          var img = $overlay.get(0);
          clearTimeout(hoverTimer);
          hoverTimer = setTimeout(function(){
            if(!$wrapEl || !$wrapEl.length) return;
            if(!shouldEnable()) return;
            if(!$wrapEl.is(':hover')) return;
            if(!img || !img.complete || img.naturalWidth === 0) return;
            $wrapEl.addClass('es-pdp-hovering');
          }, HOVER_DELAY_MS);
        });
        $wrapEl.on('mouseleave', function(){
          clearTimeout(hoverTimer);
          hoverTimer = null;
          $wrapEl.removeClass('es-pdp-hovering');
        });
      }

      function bindGalleryEvents(){
        if(w.__esPdpHoverSwapGalleryBound) return;
        var tries = 0;
        (function waitForGallery(){
          tries++;
          var $g = $('.js_prod_main').first();
          if($g.length && $g.hasClass('slick-initialized')){
            $g.off('afterChange.esPdpHoverSwap').on('afterChange.esPdpHoverSwap', function(){
              if(w.ES_PDP_HoverSwap && typeof w.ES_PDP_HoverSwap.update === 'function') {
                w.ES_PDP_HoverSwap.update();
              }
            });
            w.__esPdpHoverSwapGalleryBound = true;
            return;
          }
          if(tries < 18) setTimeout(waitForGallery, 140);
        })();
      }

      function buildVariantIndex(){
        if(w.ES_PDP__variantsById) return w.ES_PDP__variantsById;
        var map = {};
        try { (w.ES_PDP_VARIANTS || []).forEach(function(v){ map[v.id] = v; }); } catch(e) {}
        w.ES_PDP__variantsById = map;
        return map;
      }

      function getCurrentVariant(){
        try{
          var $sel = $('#productSelect');
          if(!$sel.length) return null;
          var id = parseInt($sel.val(), 10);
          if(!id) return null;
          return buildVariantIndex()[id] || null;
        } catch(e){ return null; }
      }

      function getSelectedColor(variant){
        if(!variant) return null;
        var idx = (w.ES_PDP_COLOR_OPTION_INDEX != null) ? w.ES_PDP_COLOR_OPTION_INDEX : 0;
        if(variant.options && variant.options.length) return variant.options[idx] || null;
        if(idx === 0) return variant.option1 || null;
        if(idx === 1) return variant.option2 || null;
        if(idx === 2) return variant.option3 || null;
        return null;
      }

      function getActiveImageSrc(){
        var $img = $('.js_prod_main.slick-initialized .slick-current img').first();
        if(!$img.length) $img = $('.js_prod_main img').first();
        if(!$img.length){
          $img = $('.main_img .engoj_img_main').first();
          if(!$img.length) $img = $('.engoj_img_main').first();
        }
        return ($img && $img.length) ? ($img.attr('src') || '') : '';
      }

      function getImageObjBySrc(src){
        var images = w.ES_PDP_IMAGES || [];
        if(!images.length || !src) return null;
        var cur = normalize(src);
        for(var i=0;i<images.length;i++){
          var s = normalize(images[i].src);
          if(!s) continue;
          if(cur.indexOf(s) !== -1 || s.indexOf(cur) !== -1) return images[i];
        }
        return null;
      }

      function listByVariantIds(ids){
        var images = w.ES_PDP_IMAGES || [];
        if(!images.length || !ids || !ids.length) return [];
        var set = {};
        for(var i=0;i<ids.length;i++) set[ids[i]] = 1;
        var out = [];
        images.forEach(function(img){
          if(!img || !img.src || !img.variant_ids || !img.variant_ids.length) return;
          for(var j=0;j<img.variant_ids.length;j++){
            if(set[img.variant_ids[j]]) { out.push(img.src); return; }
          }
        });
        return out;
      }

      function listForColor(color){
        var images = w.ES_PDP_IMAGES || [];
        if(!images.length || !color) return [];
        var out = [];
        var lc = String(color).toLowerCase();
        var idx = (w.ES_PDP_COLOR_OPTION_INDEX != null) ? w.ES_PDP_COLOR_OPTION_INDEX : 0;
        var variantsById = buildVariantIndex();
        images.forEach(function(img){
          if(!img || !img.src) return;
          var match = false;
          var alt = (img.alt || '').toLowerCase();
          if(alt && alt.indexOf(lc) !== -1) match = true;
          if(!match && img.variant_ids && img.variant_ids.length){
            for(var i=0;i<img.variant_ids.length;i++){
              var v = variantsById[img.variant_ids[i]];
              if(v && v.options && v.options[idx] === color){ match = true; break; }
            }
          }
          if(match) out.push(img.src);
        });
        return out;
      }

      function chooseNextInList(list, currentSrc){
        if(!list || list.length < 2) return null;
        var cur = normalize(currentSrc);
        var idx = -1;
        for(var i=0;i<list.length;i++){
          var n = normalize(list[i]);
          if(!n || !cur) continue;
          if(cur.indexOf(n) !== -1 || n.indexOf(cur) !== -1){ idx = i; break; }
        }
        if(idx === -1) idx = 0;
        var next = (idx + 1) % list.length;
        if(next === idx) return null;
        return list[next] || null;
      }

      function clearAlt(){
        if(!$overlay || !$overlay.length) return;
        lastAlt = '';
        $wrapEl && $wrapEl.removeClass('es-pdp-hovering');
        $overlay.removeAttr('src');
      }

      function setAlt(url){
        if(!$overlay || !$overlay.length) return;
        if(!url) { clearAlt(); return; }
        if(normalize(url) === normalize(lastAlt)) return;
        lastAlt = url;
        $wrapEl && $wrapEl.removeClass('es-pdp-hovering');
        $overlay.removeAttr('src');
        var pre = new Image();
        pre.onload = function(){
          if(!$overlay || !$overlay.length) return;
          $overlay.attr('src', url);
          if($wrapEl && $wrapEl.length && $wrapEl.is(':hover') && shouldEnable()){
            clearTimeout(hoverTimer);
            hoverTimer = setTimeout(function(){
              if($wrapEl && $wrapEl.is(':hover')) $wrapEl.addClass('es-pdp-hovering');
            }, HOVER_DELAY_MS);
          }
        };
        pre.src = url;
      }

      function chooseAlt(currentSrc, variant){
        var images = w.ES_PDP_IMAGES || [];
        if(!images.length || !currentSrc) return null;
        var curObj = getImageObjBySrc(currentSrc);
        if(curObj && curObj.variant_ids && curObj.variant_ids.length){
          var listByIds = listByVariantIds(curObj.variant_ids);
          var alt1 = chooseNextInList(listByIds, currentSrc);
          if(alt1) return alt1;
        }
        var color = getSelectedColor(variant);
        if(color){
          var listColor = listForColor(color);
          var alt2 = chooseNextInList(listColor, currentSrc);
          if(alt2) return alt2;
        }
        var all = images.map(function(i){ return i.src; });
        return chooseNextInList(all, currentSrc);
      }

      function update(variant){
        ensureOverlay();
        if(!$overlay || !$overlay.length) return;
        variant = variant || getCurrentVariant();
        var currentSrc = getActiveImageSrc();
        if(!currentSrc){ clearAlt(); return; }
        var alt = chooseAlt(currentSrc, variant);
        if(alt && normalize(alt) !== normalize(currentSrc)) setAlt(alt);
        else clearAlt();
      }

      return { update: update };
    })();

    w.selectCallback = function(variant, selector) {
      try {
        w.ES_PDP_SELECTED_VARIANT = variant || null;
        w.ES_PDP_SELECTED_VARIANT_ID = variant && variant.id ? String(variant.id) : '';
        var lbWindow = d.querySelector('[data-es-lb-root] .es-lb__window');
        if (lbWindow && variant) {
          if (variant.id) lbWindow.setAttribute('data-selected-variant-id', String(variant.id));
          lbWindow.setAttribute('data-selected-variant-title', String(variant.title || ''));
          lbWindow.setAttribute('data-selected-variant-price', String(Number(variant.price || 0) || 0));
        }
        if (variant && variant.id) {
          d.dispatchEvent(new CustomEvent('es:pdp:variant', { detail: { variant: variant } }));
        }
      } catch(e) {}

      var form = (selector && selector.domIdPrefix) ? $('#' + selector.domIdPrefix).closest('form') : $();
      if (variant && form.length) {
        for (var i=0,length=variant.options.length; i<length; i++) {
          var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] + '"]');
          if (radioButton.length) radioButton.get(0).checked = true;
        }
      }

      var $esAtc = form.length ? form.find('.engoj-btn-addtocart').first() : $('.engoj-btn-addtocart').first();
      var ES_ATC_TEXT = $esAtc.attr('data-es-add-to-cart') || ($esAtc.data && $esAtc.data('esAddToCart')) || $.trim($esAtc.text()) || $esAtc.val() || 'Add to Cart';
      var ES_OOS_TEXT = $esAtc.attr('data-es-out-of-stock') || ($esAtc.data && $esAtc.data('esOutOfStock')) || 'Out of stock';
      var ES_UNAVAILABLE_TEXT = $esAtc.attr('data-es-unavailable') || ($esAtc.data && $esAtc.data('esUnavailable')) || ES_OOS_TEXT;

      if (variant) {
        if (variant.available) {
          $esAtc.removeClass('disabled es-pdp-oos-visual').removeAttr('disabled').removeAttr('aria-disabled').val(ES_ATC_TEXT).text(ES_ATC_TEXT).fadeTo(200, 1);
          applyPdpSoldOutCtaVisual($esAtc, false);
        } else {
          $esAtc.val(ES_OOS_TEXT).text(ES_OOS_TEXT).addClass('disabled es-pdp-oos-visual').attr('disabled', 'disabled').attr('aria-disabled', 'true').fadeTo(200, 1);
          applyPdpSoldOutCtaVisual($esAtc, true);
        }
        if (variant.compare_at_price > variant.price) {
          $('.enj-product-price').html(Shopify.formatMoney(variant.price, w.money_format));
          $('.enj-product-price-compare').html(Shopify.formatMoney(variant.compare_at_price, w.money_format)).show();
        } else {
          $('.enj-product-price').html(Shopify.formatMoney(variant.price, w.money_format));
          $('.enj-product-price-compare').html('').hide();
        }
      } else {
        $esAtc.val(ES_UNAVAILABLE_TEXT).text(ES_UNAVAILABLE_TEXT).addClass('disabled es-pdp-oos-visual').attr('disabled', 'disabled').attr('aria-disabled', 'true').fadeTo(200, 1);
        applyPdpSoldOutCtaVisual($esAtc, true);
      }

      if (variant && variant.featured_image) {
        var originalImage = $('.engoj_img_main');
        var newImage = variant.featured_image;
        var element = originalImage[0];
        if (element) {
          Shopify.Image.switchImage(newImage, element, function (newImageSizedSrc, newImage2, element2) {
            var $el = $(element2);
            swapPdpMainImageWhenReady($el, newImageSizedSrc, function(){
              $('.engoj-nav-item:eq(0)').trigger('click');
            });
          });
        }
      }

      if (variant && variant.featured_image) {
        var originalImage2 = $('.engoj_img_main');
        var newImage2 = variant.featured_image;
        var element2 = originalImage2[1];
        if (element2) {
          Shopify.Image.switchImage(newImage2, element2, function (newImageSizedSrc, newImage3, element3) {
            var $el = $(element3);
            swapPdpMainImageWhenReady($el, newImageSizedSrc);
          });
        }
      }

      if (w.ES_PDP_HoverSwap && typeof w.ES_PDP_HoverSwap.update === 'function') {
        setTimeout(function(){ w.ES_PDP_HoverSwap.update(variant); }, 140);
      }
    };

    function initOptionSelectors(){
      if (w.__ES_PDP_OPTION_SELECTORS_INIT__) return;
      if (!(w.Shopify && typeof w.Shopify.OptionSelectors === 'function')) {
        setTimeout(initOptionSelectors, 80);
        return;
      }
      w.__ES_PDP_OPTION_SELECTORS_INIT__ = true;
      new Shopify.OptionSelectors('productSelect', {
        product: productData,
        onVariantSelected: w.selectCallback,
        enableHistoryState: true
      });

      if (w.ES_PDP_HoverSwap && typeof w.ES_PDP_HoverSwap.update === 'function') {
        setTimeout(function(){ w.ES_PDP_HoverSwap.update(); }, 650);
      }

      if (productData.options && productData.options.length === 1 && productData.options[0] !== 'Title') {
        $('.selector-wrapper:eq(0)').prepend('<label for="productSelect-option-0">' + String(productData.options[0]) + '</label>');
      }
      if (productData.variants && productData.variants.length === 1 && /Default/.test(String(productData.variants[0].title || ''))) {
        $('.selector-wrapper').hide();
      }
    }

    function initPdpTextOptionBridge(){
      if (w.__ES_PDP_TEXT_OPTION_BRIDGE__) return;
      w.__ES_PDP_TEXT_OPTION_BRIDGE__ = true;

      function getOptionIndex(input){
        var swatch = input && input.closest ? input.closest('.swatch[data-option-index]') : null;
        if (!swatch) return -1;
        var idx = parseInt(swatch.getAttribute('data-option-index'), 10);
        return isNaN(idx) ? -1 : idx;
      }

      function getForm(input){
        return input && input.closest ? input.closest('form') : null;
      }

      function syncSelectorFromInput(input){
        try {
          if (!input || input.disabled || input.getAttribute('aria-disabled') === 'true') return;
          var idx = getOptionIndex(input);
          if (idx < 0) return;
          var form = getForm(input);
          if (!form) return;
          var selector = $(form).find('.single-option-selector').eq(idx);
          if (!selector.length) return;
          var value = $(input).val();
          if (selector.val() !== value) {
            selector.val(value).trigger('change');
          } else {
            selector.trigger('change');
          }
        } catch(e) {}
      }

      function setRadioChecked(input){
        try {
          if (!input || input.disabled || input.getAttribute('aria-disabled') === 'true') return;
          var name = input.getAttribute('name');
          var form = getForm(input) || d;
          if (name && form.querySelectorAll) {
            form.querySelectorAll('input[type="radio"][name="' + name.replace(/\"/g, '\\\"') + '"]').forEach(function(r){
              r.checked = (r === input);
            });
          } else {
            input.checked = true;
          }
          if (typeof Event === 'function') {
            input.dispatchEvent(new Event('change', { bubbles:true }));
          } else {
            var evt = d.createEvent('Event');
            evt.initEvent('change', true, true);
            input.dispatchEvent(evt);
          }
        } catch(e) {
          try { $(input).prop('checked', true).trigger('change'); } catch(_e) {}
        }
      }

      function syncTextRadiosFromSelectors(){
        try {
          $('#AddToCartForm .swatch.es-swatch--text[data-option-index]').each(function(){
            var swatch = this;
            var idx = parseInt(swatch.getAttribute('data-option-index'), 10);
            if (isNaN(idx)) return;
            var form = swatch.closest ? swatch.closest('form') : null;
            var selector = form ? $(form).find('.single-option-selector').eq(idx) : $();
            if (!selector.length) return;
            var value = selector.val();
            $(swatch).find('input[type="radio"]').each(function(){
              this.checked = ($(this).val() === value);
            });
          });
        } catch(e) {}
      }

      $(d)
        .off('click.esPdpTextOptionBridge', '#AddToCartForm .swatch.es-swatch--text .es-text-option')
        .on('click.esPdpTextOptionBridge', '#AddToCartForm .swatch.es-swatch--text .es-text-option', function(e){
          try {
            var input = this.querySelector ? this.querySelector('input[type="radio"]') : null;
            if (!input) return;
            if (!input.checked || e.target !== input) {
              setRadioChecked(input);
            } else {
              syncSelectorFromInput(input);
            }
          } catch(_e) {}
        })
        .off('change.esPdpTextOptionBridge', '#AddToCartForm .swatch.es-swatch--text input[type="radio"]')
        .on('change.esPdpTextOptionBridge', '#AddToCartForm .swatch.es-swatch--text input[type="radio"]', function(){
          if (this.checked) syncSelectorFromInput(this);
        })
        .off('change.esPdpTextSelectorSync', '#AddToCartForm .single-option-selector')
        .on('change.esPdpTextSelectorSync', '#AddToCartForm .single-option-selector', function(){
          w.setTimeout(syncTextRadiosFromSelectors, 0);
        });

      w.setTimeout(syncTextRadiosFromSelectors, 80);
      w.setTimeout(syncTextRadiosFromSelectors, 350);
      w.setTimeout(syncTextRadiosFromSelectors, 900);
    }

    initOptionSelectors();
    initLinkedOptions();
    initPdpTextOptionBridge();
    applyPdpSoldOutCtaVisual();
    w.setTimeout(applyPdpSoldOutCtaVisual, 80);
    w.setTimeout(applyPdpSoldOutCtaVisual, 350);
    w.setTimeout(applyPdpSoldOutCtaVisual, 1000);
  });
})(window, document);
